import(/* webpackMode: "eager" */ "/home/ubuntu/download/6998c1f4f782d50014ce3fca/chronomind_ai_governance/src/app/privacy-policy/page.tsx");
